<template>
  <div>
    <Header></Header>
    <div id="main">

      <div class="container">
        <div v-if="showMsg" class="alert alert-danger alert-dismissible fade show" role="alert">
          {{msg}}
          <button type="button" class="close" data-dismiss="alert" aria-label="Fechar" v-on:click.stop.prevent="hideMsg()">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div v-if="showMsgSuccess" class="alert alert-success alert-dismissible fade show" role="alert">
          {{msgSuccess}}
          <button type="button" class="close" data-dismiss="alert" aria-label="Fechar" v-on:click.stop.prevent="hideMsg()">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="row">

          <div class="col-md-12" v-if="user">
            <h1>Bem vindo, {{userFirstname}}!</h1>
            <h4 v-if="user.profile == 'ong'">Deseja cadastrar sua Organização Social? Criar um evento solidário? Acesse as opções abaixo:</h4>
            <h4 v-else>Deseja fazer uma doação? Acesse as opções abaixo:</h4>

            <div class="menu">
              <ul>
                <li>
                  <router-link to="/projects" v-if="user.profile != 'ong'">
                    <font-awesome-icon :icon="['fas', 'dollar-sign']" size="lg" />
                    <span>Fazer uma Doação</span>
                  </router-link>
                </li>
                <li>
                  <router-link to="/create-project" v-if="user.profile == 'ong'">
                    <font-awesome-icon :icon="['far', 'envelope']" size="lg" />
                    <span>Cadastrar sua ONG</span>
                  </router-link>
                </li>
                <li>
                  <router-link to="/create-project/event" v-if="user.isAdmin">
                    <font-awesome-icon :icon="['fas', 'gift']" size="lg" />
                    <span>Convite do Bem</span>
                  </router-link>
                </li>
                <li>
                  <router-link to="/profile">
                    <font-awesome-icon :icon="['far', 'user']" size="lg" />
                    <span>Editar seu Perfil</span>
                  </router-link>
                </li>
                <li>
                  <router-link to="/descontosdobem">
                    <font-awesome-icon :icon="['fas', 'hand-holding-usd']" size="lg" />
                    <span>Descontos do Bem</span>
                  </router-link>
                </li>
                <li v-if="user.isPartner && user.profile == 'ong'">
                  <router-link to="/profile?tab=campaigns">
                    <font-awesome-icon :icon="['fas', 'shopping-cart']" size="lg" />
                    <span>Criar Campanha</span>
                  </router-link>
                </li>
                <li>
                  <router-link to="/profile/my-donations" v-if="user.profile != 'ong'">
                    <font-awesome-icon :icon="['fas', 'chart-line']" size="lg" />
                    <span>Extrato Social</span>
                  </router-link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

    </div>
    <Footer></Footer>
    <Loading v-if="loading" message="Aguarde, preparando a sua Dashboard..."></Loading>
  </div>
</template>

<script>

import Header from './includes/Header'
import Footer from './includes/Footer'
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
import {faDollarSign, faGift, faHandHoldingUsd, faShoppingCart} from '@fortawesome/fontawesome-free-solid'
import {faEnvelope, faHeart, faUser} from '@fortawesome/fontawesome-free-regular'
import {faFacebookF} from '@fortawesome/fontawesome-free-brands'
import Loading from './includes/Loading'
import auth from '../services/auth'
import Functions from '../utils/functions'
import { API } from '../services/api'

export default {
  name: 'Profile',
  components: {
    Header,
    Footer,
    FontAwesomeIcon,
    Loading
  },
  data () {
    return {
      user: null,
      userFirstname: "",
      msg: "",
      showMsg: false,
      msgSuccess: "",
      showMsgSuccess: false,
      loading: true
    }
  },
  created(){
    this.getProfile();
  },
  mounted (){
    if(this.$route.params.token){
      this.$http.post(API.Auth.confirmEmail, {token: this.$route.params.token}).then((res) =>{
        this.msgSuccess = res.body.message;
        this.showMsgSuccess = true;
      }, (err) => {
        this.msg = err.body.message;
        this.showMsg = true;
      });
    }
  },
  methods: {
    getProfile(){
      this.$http.get(API.Profile.profile, {headers: auth.getHeaders()}).then((result) => {
        this.user = result.body.user;
        if(this.user.Info && this.user.Info.fullname){
          this.userFirstname = this.user.Info.fullname.split(" ")[0];
        }else{
          this.userFirstname = this.user.username;
        }
        this.loading = false;
      }, (err) => {
        auth.logout();
        this.$router.push('/login');
      });
    },
    hideMsg(){
      this.msg = "";
      this.showMsg = false;
      this.msgSuccess = "";
      this.showMsgSuccess = false;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
h1{
  font-weight: bold;
  color: #00ae39;
  text-align: center;
}
h4{
  text-align: center;
  @media screen and (max-width: 767px ){
    font-size: 16px;
  }
}
.menu{
  margin-top: 20px;
  ul{
    padding: 0px;
    list-style: none;
    text-align: center;

    li{
      display: inline-block;
      margin-right: 10px;
      margin-left: 10px;
      margin-top: 10px;


      a{
        display: block;
        padding: 20px;
        border: 2px solid #00ae39;
        border-radius: 5px;
        font-size: 28px;
        color: #00ae39;
        text-decoration: none;
        &:hover{
          color: #999;
          border: 2px solid #999;
        }
        svg{
          display: block;
          margin: 0 auto;
        }
        span{
          font-size: 14px;
          margin-top: 10px;
          font-weight: bold;
          width: 150px;
          display: block;
        }
      }

      @media screen and (max-width: 767px ){
        display: list-item;

        span{
          width: 100% !important;
        }

      }

    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard.vue